<template>
    <modal
        :click-to-close="false"
        height="auto"
        name="pos-mode"
        width="95%"
        :max-width="450"
        :adaptive="true"
    >
        <div class="pos-mode-body">
            <template v-if="!checkoutComplete">
                <span class="close-button" @click="$modal.hide('pos-mode')">x</span>
                <div class="modal-text">
                    <h2>Your BLD is complete!</h2>
                    <h5>Want to buy your custom BLD today?</h5>
                    <p>Enter your email address below and see a staff member at checkout to purchase your BLD and have it shipped within 48 hours. </p>
                    <h5>Not ready to buy it yet?</h5>
                    <p>No worries! You can save your BLD for later by entering your email below.</p>
                </div>
                <div class="container-fluid">
                    <div class="row">
                        <div class="col">
                            <form @submit.prevent="posCheckout()">
                                <div class="form-group">
                                    <span
                                        v-show="errors.has('email')"
                                        class="pos-error"
                                    >
                                        {{ errors.first('email') }}
                                    </span>
                                    <input
                                        v-model="email"
                                        v-validate="'required|email'"
                                        class="form-control"
                                        name="email"
                                        placeholder="puck@nzxtfriends.com"
                                        type="text"
                                    >
                                </div>
                                <div class="checkbox">
                                    <span
                                        v-show="errors.has('agree')"
                                        class="pos-error"
                                    >
                                        {{ errors.first('agree') }}
                                    </span>
                                    <input
                                        id="pos-agree-newsletter"
                                        v-model="agree"
                                        name="agree"
                                        type="checkbox"
                                    >
                                    <label for="pos-agree-newsletter">
                                        Keep me up-to-date with news and exclusive offers from NZXT and BLD
                                    </label>
                                </div>
                                <div class="text-center">
                                    <button
                                        :class="{ 'disable-element': isCheckingout }"
                                        class="btn btn-purple"
                                        type="submit"
                                    >
                                        <template v-if="!isCheckingout">Complete</template>
                                        <span class="completing" v-else>
                                            Completing
                                        </span>
                                    </button>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </template>
            <template v-else>
                <h2>Success!</h2>
                <p>Success! You should receive an email with your BLD shortly.</p>
                <div class="text-center">
                    <button class="btn btn-purple" @click="closeModal()">Okay</button>
                </div>
            </template>
        </div>
    </modal>
</template>

<script>
import { mapState } from "vuex";
import { configuratorMixins } from "@u/mixins";

export default {
    name: "PosModeModal",
    mixins: [
        configuratorMixins
    ],
    data() {
        return {
            agree: true,
            checkoutComplete: false,
            email: "",
            isCheckingout: false
        }
    },
    computed: {
        ...mapState({
            draftId: state => state.Step4.draftId
        })
    },
    methods: {
        closeModal() {
            this.restartBuild();
            this.$router.push({
                name: "home"
            });
            this.$modal.hide("pos-mode");
        },
        async posCheckout() {
            this.isCheckingout = true;

            const isValid = await this.$validator.validateAll();

            if (!isValid) {
                this.isCheckingout = false;
                return;
            }

            const formData = new FormData();
            formData.append("bld_number_draft", this.draftId);
            formData.append("email", this.email);
            formData.append("signup_for_newsletter", this.agree);

            axios({
                method: "POST",
                url: "/pos/checkout",
                headers: {
                    'token': window.CONFIG.SESSION
                },
                data: formData
            }).then(response => {
                this.checkoutComplete = true;
            }).catch(error => {
                this.$modal.show("general", {
                    title: "Error",
                    content: error.response.data.status.message,
                    zIndex: 1010
                });
            }).finally(() => {
                this.isCheckingout = false;
            });
        }
    }
}
</script>

<style lang="scss">
@import "~@s/_asset-mixers.scss";

.v--modal-overlay[data-modal="pos-mode"] {
    background-color: rgba(0, 0, 0, 0.7);

    .v--modal-box {
        background-color: transparent;
        border: 1px solid white;
        max-width: 100%;

        .pos-mode-body {
            background-color: rgba(17, 17, 15, 0.8);
            color: #fff;
            font-family: "Akkurat-Light";
            font-size: 14px;
            padding: 30px;
            position: relative;

            .close-button {
                cursor: pointer;
                font-size: 18px;
                line-height: 18px;
                position: absolute;
                right: 10px;
                top: 10px;
            }

            h2 {
                font-family: "Akkurat-Normal";
                font-size: 22px;
                margin-bottom: 20px;
                margin-top: 0;
                color: #fff;
                letter-spacing: 2px;
            }

            .modal-text {
                h5 {
                    margin-bottom: 3px;
                    font-family: 'Akkurat-Bold';
                }
            }

            .checkbox {
                label::before {
                    height: 17px;
                    width: 17px;
                    border-radius: 3px;
                }
            }

            .btn-purple {
                padding: 10px 58px;

                &:hover {
                    background: $purple;
                    border-color: $purple;
                    color: $white;
                }
            }

            .form-group {
                position: relative;
            }

            .pos-error {
                position: absolute;
                top: -31px;
                left: 0;
                background-color: $purple;
                padding: 5px;
                border-radius: 10px;

                &::after {
                    border-color: $purple;
                    border-bottom-color: transparent !important;
                    border-left-color: transparent !important;
                    border-right-color: transparent !important;
                    border-style: solid;
                    border-width: 5px 5px 0 5px;
                    bottom: -4px;
                    content: "";
                    height: 0;
                    left: 1px;
                    position: absolute;
                    width: 0;
                    z-index: 1;
                }
            }

            .completing {
                background-image: url("/assets/spinner-white.svg");
                background-position: 0 -8px;
                background-size: 32px;
                background-repeat: no-repeat;
                padding-left: 30px;

                &::after {
                    content: "";
                    animation: loadingdots 1s infinite ease-in-out;
                    position: absolute;
                }
            }
        }
    }
}
</style>
